import { onKey } from "./onKey.js";
import { shortcutsById } from "./shortcutRegistry.js";

export function createAppShortcutBindings({ navigateToPage }) {
  return [
    onKey(shortcutsById.get("go-help").binding, () => navigateToPage("help")),
    onKey(shortcutsById.get("go-settings").binding, () => navigateToPage("settings"))
  ];
}
